import { CollaboratoreDTO } from './../domain/collaboratore';
import { TenantDTO } from './../domain/tenant';
import { LogicalDeleteDTO } from './../basic/logicalDeleteDTO';

export class CollaboratoreAMDTO extends LogicalDeleteDTO {
    id: number;
    tenant: TenantDTO;
    collaboratore: CollaboratoreDTO;
}